// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_navbarContainer__EJEgh {
  max-width: 98.5%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  margin-top: 10px;
  margin-inline: auto;
  padding: 12px 24px;
  padding-right: 30px;
  background-color: var(--border-green);
}

.Header_headerTextCont__eU1Ut > h4 {
  font-weight: 700;
  margin-bottom: 0px !important;
}

.Header_imgNameCont__Ilzov {
  display: flex;
  align-items: center;
  gap: 10px;
}

.Header_avatarImageCont__HUe1h {
  position: relative;
  width: 40px;
  height: 40px;
}

.Header_avatarImageCont__HUe1h > img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  cursor: pointer;
}

.Header_headerIcons__2qsDr {
  display: flex;
  gap: 10px;
  align-items: center;
}

.Header_headerIcons__2qsDr .Header_iconBox__-EBgL {
  background-color: var(--white-v1);
  border-radius: 100%;
  padding: 10px;
  cursor: pointer;
}

.Header_userCont__x\\+7yR {
  display: flex;
  align-items: center;
  gap: 10px;
}

.Header_userCont__x\\+7yR > p {
  color: var(--dark-v1);

  font-size: 22px;
  font-weight: 600;
  margin-bottom: 0px !important;
  cursor: pointer;
}
.Header_GiHamburgerMenu__KMNu7 {
  background-color: var(--border-green);
  color: var(--black-color);
  font-size: 30px;
}

@media screen and (max-width: 768px) {
}
`, "",{"version":3,"sources":["webpack://./src/Components/organisms/Header/Header.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;;EAErB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;AACA","sourcesContent":[".navbarContainer {\n  max-width: 98.5%;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 12px;\n  margin-top: 10px;\n  margin-inline: auto;\n  padding: 12px 24px;\n  padding-right: 30px;\n  background-color: var(--border-green);\n}\n\n.headerTextCont > h4 {\n  font-weight: 700;\n  margin-bottom: 0px !important;\n}\n\n.imgNameCont {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.avatarImageCont {\n  position: relative;\n  width: 40px;\n  height: 40px;\n}\n\n.avatarImageCont > img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.headerIcons {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.headerIcons .iconBox {\n  background-color: var(--white-v1);\n  border-radius: 100%;\n  padding: 10px;\n  cursor: pointer;\n}\n\n.userCont {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.userCont > p {\n  color: var(--dark-v1);\n\n  font-size: 22px;\n  font-weight: 600;\n  margin-bottom: 0px !important;\n  cursor: pointer;\n}\n.GiHamburgerMenu {\n  background-color: var(--border-green);\n  color: var(--black-color);\n  font-size: 30px;\n}\n\n@media screen and (max-width: 768px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbarContainer": `Header_navbarContainer__EJEgh`,
	"headerTextCont": `Header_headerTextCont__eU1Ut`,
	"imgNameCont": `Header_imgNameCont__Ilzov`,
	"avatarImageCont": `Header_avatarImageCont__HUe1h`,
	"headerIcons": `Header_headerIcons__2qsDr`,
	"iconBox": `Header_iconBox__-EBgL`,
	"userCont": `Header_userCont__x+7yR`,
	"GiHamburgerMenu": `Header_GiHamburgerMenu__KMNu7`
};
export default ___CSS_LOADER_EXPORT___;
